module.exports = __webpack_public_path__ + "img/logo-on-dark.457c4003.png";